import { render, staticRenderFns } from "./deleteMenuCatalog.vue?vue&type=template&id=562b9c3a"
import script from "./deleteMenuCatalog.vue?vue&type=script&lang=js"
export * from "./deleteMenuCatalog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports